// extracted by mini-css-extract-plugin
module.exports = {"logo":"SchoolSelector_logo__2hgnb","school":"SchoolSelector_school__2KG-v","active":"SchoolSelector_active__1UU0N"};